import module from 'nominas/sumario/module.js'
import template from './template.html'
import './style.scss'

const catalogoNominaRevision = [
  {id: 'maquila', descripcion: 'Maquila'},
  {id: 'revision', descripcion: 'Revisada'},
  {id: 'cierre', descripcion: 'Cierre'},
  {id: 'estado_cuenta', descripcion: 'Estado de cuenta generado'},
  {id: 'timbrado', descripcion: 'Timbrado'},
  {id: 'imprimir_cfdi', descripcion: 'CFDI impreso'},
  {id: 'envio_cfdi', descripcion: 'CFDI enviado'},
  {id: 'factura', descripcion: 'Factura'},
  {id: 'pagado', descripcion: 'Pagado'},
  {id: 'dispersado', descripcion: 'Dispersado'},
  {id: 'visible', descripcion: 'Visible'},
]

export class NominasSumarioListaItemRevisionesComponent {
  idProyecto
  idNomina
  data
  editable
  onChange
  procesando = {}
  catalogo = {
    nominaRevision: catalogoNominaRevision,
  }

  constructor (NominasSumario) {
    this.NominasSumario = NominasSumario
  }

  toggle (revision) {
    if (!this.editable || this.procesando[revision]) return

    this.procesando[revision] = true

    this.data[revision] = !this.data[revision]

    return this.NominasSumario.review(this.idProyecto, this.idNomina, {revision: revision, status: this.data[revision]})
      .then((response) => (this.data[revision] = response.data.status))
      .finally(() => (this.procesando[revision] = false))
  }
}

module.component('nominasSumarioListaItemRevisiones', {
  controller: NominasSumarioListaItemRevisionesComponent,
  template,
  bindings: {
    idProyecto: '<',
    idNomina: '<',
    data: '<',
    editable: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/lista/item/revisiones/component.js